import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [translations, setTranslations] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setLanguage(savedLanguage);
    
    fetch('/translations.json')
      .then(response => response.json())
      .then(data => {
        setTranslations(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Failed to load translations:', error);
        setLoading(false);
      });
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  const t = (path) => {
    const keys = path.split('.');
    let value = translations[language];
    
    for (const key of keys) {
      if (value && typeof value === 'object') {
        value = value[key];
      } else {
        return path;
      }
    }
    
    return value || path;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, loading, availableLanguages: Object.keys(translations) }}>
      {children}
    </LanguageContext.Provider>
  );
};
